export default __webpack_public_path__ + "static/media/Wordpress_TrackStar_ai_Predictive_Credit_Technology.f728657f.png";